import { Logger } from './logger';

let errorCallbackImport: Promise<typeof import('./logger')>;

if (typeof window === 'undefined') {
  errorCallbackImport = import('./logger');
}

export default async (err: unknown): Promise<void> => {
  const { default: errorCallback } = await errorCallbackImport;

  // NOTE: We are using type assertions since we do in fact no better than the
  // compiler that `Logger` is only used on the server and that `Client` is used
  // on the client.
  if (typeof window === 'undefined') {
    (errorCallback as Logger).error({ err }, 'error thrown');
  }
};
